import { Link, useLocation } from 'react-router-dom';
import { Zap } from 'lucide-react';

export default function Navbar() {
  const loc = useLocation();

  return (
    <header
      style={{
        background: 'var(--surface)',
        borderBottom: '1px solid var(--border)',
      }}
      className="flex items-center gap-4 px-5 h-12 flex-shrink-0 z-10"
    >
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 no-underline">
        <span
          style={{ background: 'var(--primary)', borderRadius: 7 }}
          className="w-7 h-7 flex items-center justify-center"
        >
          <Zap size={14} color="#0B0E14" strokeWidth={2.5} />
        </span>
        <span
          style={{ fontFamily: 'IBM Plex Mono', color: 'var(--text)', fontWeight: 600 }}
          className="text-sm tracking-tight"
        >
          PipeDream CF
        </span>
      </Link>

      <div style={{ color: 'var(--border-2)' }} className="text-sm select-none">
        /
      </div>

      {/* Dynamic breadcrumb */}
      <nav className="flex items-center gap-2 text-sm" style={{ color: 'var(--text-dim)' }}>
        <Link to="/" style={{ color: 'var(--text-dim)' }} className="hover:text-white transition-colors no-underline">
          Workflows
        </Link>

        {loc.pathname.startsWith('/workflows/') && !loc.pathname.endsWith('/new') && (
          <>
            <span style={{ color: 'var(--border-2)' }}>/</span>
            <span style={{ color: 'var(--text)' }}>
              {loc.pathname.endsWith('/runs') ? 'Runs' : 'Editor'}
            </span>
          </>
        )}

        {loc.pathname === '/workflows/new' && (
          <>
            <span style={{ color: 'var(--border-2)' }}>/</span>
            <span style={{ color: 'var(--text)' }}>New Workflow</span>
          </>
        )}
      </nav>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Docs link */}
      <a
        href="https://developers.cloudflare.com/workers/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'var(--text-muted)', fontSize: '.8rem' }}
        className="hover:text-white transition-colors"
      >
        CF Docs ↗
      </a>
    </header>
  );
}
